import { Spiner } from '@/shared/ui/spiner'
import { useStyles } from './styles'
import { RewardPreview } from '@/shared/ui/rewardPreview'
import { useUnit } from 'effector-react'
import { $caseContent } from '@/entities/cases'
import { RewardType } from '@/widgets/boxes/rewardClaim/types'
type SortStrategy = 'none' | 'byKind' | 'byAmount'

type RewardListProps = {
  folder: string
  mockForGiftCase?: boolean
  sortStrategy?: SortStrategy
}

export const RewardList = ({ folder, mockForGiftCase, sortStrategy = 'none' }: RewardListProps) => {
  const { classes } = useStyles()
  const rewards = useUnit($caseContent)?.sort((a, b) => Number(b.name) - Number(a.name))
  const sortRewards = (rewards: RewardType[], strategy: SortStrategy): RewardType[] => {
    switch (strategy) {
      case 'byKind':
        return [...rewards].sort((a, b) => b.kind - a.kind)

      case 'byAmount':
        return [...rewards].sort((a, b) => {
          const amountA = a.name || Number(a.name)
          const amountB = b.name || Number(b.name)
          return Number(amountB) - Number(amountA)
        })

      case 'none':
      default:
        return rewards
    }
  }

  const sortedRewards = rewards ? sortRewards(rewards, sortStrategy) : null

  return (
    <div className={classes.rewardListWrapper}>
      {mockForGiftCase && (
        <RewardPreview
          boxName={folder}
          text="Telegram Premium for 1 year"
          rarity={5}
          kind={0}
          isIcon={true}
        />
      )}

      {sortedRewards ? (
        sortedRewards.map((reward, index) => (
          <RewardPreview
            boxName={folder}
            amountOfPoints={Number(reward.name)}
            kind={reward.kind}
            key={index}
            rarity={reward.rarity}
            isIcon={true}
          />
        ))
      ) : (
        <Spiner size="l" />
      )}
    </div>
  )
}
